import type { SavingEnvelopesConfig } from './SavingEnvelopesConfig';

export const savingEnvelopes: SavingEnvelopesConfig = {
    maxEnvelopeLimit: 10,
    showEnvelopeNumberInfo: false,
    filterUserEnvelopesOnFrontend: false,
    amountInputMaxLength: 0,
    targetClientId: '',
    envelopeNameMatchString: /^(?:[a-zA-Zá-žÁ-Ž0-9][a-zA-Zá-žÁ-Ž0-9 ]*)?$/.toString(),
    envelopeNameLength: 40,
    envelopeNameErrorTranslationKey: '',
};
